import React, { ComponentType, useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import PageLoader from '../../components/layout/page-loader/PageLoader';

type UnknownProps = Record<string, unknown>;

interface AuthGuardProps {
  component: ComponentType<UnknownProps>;
}

export const AuthenticationGuard: React.FC<AuthGuardProps> = ({
  component,
}: AuthGuardProps) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const hasTriggeredRedirect = useRef(false);

  useEffect(() => {
    if (isAuthenticated) {
      hasTriggeredRedirect.current = false;
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isLoading || isAuthenticated || hasTriggeredRedirect.current) {
      return;
    }

    hasTriggeredRedirect.current = true;
    const returnTo = `${window.location.pathname}${window.location.search}${window.location.hash}`;

    void loginWithRedirect({ appState: { returnTo } }).catch((error) => {
      hasTriggeredRedirect.current = false;
      console.error('[Auth] login redirect failed', error);
    });
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  if (isLoading) {
    return <PageLoader />;
  }

  if (isAuthenticated) {
    const AllowedComponent = component;
    return <AllowedComponent />;
  }

  return <PageLoader />;
};
